import { render, staticRenderFns } from "./PlayPauseButton.vue?vue&type=template&id=224d03eb&scoped=true&"
import script from "./PlayPauseButton.vue?vue&type=script&lang=ts&"
export * from "./PlayPauseButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlayPauseButton.vue?vue&type=style&index=0&id=224d03eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d03eb",
  null
  
)

export default component.exports